import authorization from './authorization';

export default authorization;
